export default "__VITE_ASSET__a6f3cb36__"